import script from "./PaWorkspace.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaWorkspace.vue?vue&type=script&setup=true&lang=ts"

import "./PaWorkspace.vue?vue&type=style&index=0&id=5959b9cb&lang=scss&scoped=true"
import "./PaWorkspace.vue?vue&type=style&index=1&id=5959b9cb&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5959b9cb"]])

export default __exports__